<div class="app-page-title">
  <div class="page-title-wrapper">
    <div>
      <img src="./assets/images/u2.png" alt="img" width="50px" />
      <span class="page-title-text">Renewal</span>
    </div>
  </div>
</div>

<div class="main-card mb-3 card custom-card">
  <div class="card-body">
    <div class="row">
      <div class="col-md-8">
        <form [formGroup]="renewalForm">
          <div class="form-group">
            <label class="label">Package</label>
            <select formControlName="package" (change)="onPackageChange()" class="form-control">
              <option value>Select Package</option>
              <option *ngFor="let pkg of packages" [value]="pkg.name">
                {{ pkg.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="label">Sub Plan</label>
            <select formControlName="subPlan" (change)="onSubPlanChange($event.target.value)" class="form-control">
              <option value>Select Subplan</option>
              <option *ngFor="let plan of selectedPlans" [value]="plan.name">
                {{ plan.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="label comment-label">Comments</label>
            <input formControlName="comments" type="text" class="form-control" />
          </div>

          <div class="row mt-3 justify-between">
            <div class="col-lg-4 mb-3">
              <div class="main-card card expiry-card">
                <div class="card-body">
                  <p class="expiry-label">Expiry Date: {{newExpiryDate}}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-lg-4 mb-3">
              <div class="main-card card invoice-card">
                <div class="card-body">
                  <p class="invoice-label">Invoice Amount: ₹{{totalAmount}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <img src="./assets/images/pay.jpg" alt="pay1" class="payment-image" />
          </div>

          <div class="card-footer">
            <button type="button" class="mb-2 me-2 btn btn-focus">Submit</button>
            <button type="button" class="mb-2 me-2 btn btn-light" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>

      <div class="col-md-4">
        <div class="invoice invoice-breakup">
          <h3 class="fw-bold">Invoice Amount Breakups</h3>
          <p class="invoice-list"><span class="label">Plan Price:</span><span class="invoice-cont">{{ totalAmount }}</span></p>
          <p class="invoice-list"><span class="label">Default Charge:</span><span class="invoice-cont">0.00</span></p>
          <p class="invoice-list"><span class="label">Additional Charge:</span><span class="invoice-cont">0.00</span></p>
          <p class="invoice-list"><span class="label">Default Discount:</span><span class="invoice-cont">0.00</span></p>
          <p class="invoice-list"><span class="label">Additional Discount:</span><span class="invoice-cont">0.00</span></p>
          <p class="invoice-list"><span class="label">Tax:</span><span class="invoice-cont">0.00</span></p>
          <hr />
          <p class="invoice-list"><span class="label">Total Amount:</span><span class="invoice-cont">{{ totalAmount }}</span></p>
          <p class="invoice-list"><span class="label">Total Amount Need to Pay:</span><span class="invoice-cont">{{ totalAmount }}</span></p>
        </div>
      </div>
    </div>
  </div>
</div>
